import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const PROGRAMS_PROGRAM_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/programs',
        iconClass: 'fas fa-school',
        name: '::Menu:Programs',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Programs',
      },
    ]);
  };
}
